import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { toast } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomFee from 'src/components/shared/CustomFee';
import { FEE_UNIT_TYPES } from 'src/constants/feesSetting';
import { useStore } from 'src/stores';
const BillingSettingsCustomFee = observer(props => {
  const customAdminFee = props.customAdminFee,
    customLateFee = props.customLateFee,
    customFee = props.customFee,
    _props$customLateFeeS = props.customLateFeeSign,
    customLateFeeSign = _props$customLateFeeS === void 0 ? undefined : _props$customLateFeeS,
    feeDescription = props.feeDescription,
    handleChange = props.handleChange,
    handleSave = props.handleSave,
    handleCustomLateFeeSignChange = props.handleCustomLateFeeSignChange,
    lateFee = props.lateFee,
    padding = props.padding,
    setFetchFee = props.setFetchFee,
    _props$propertyAdminF = props.propertyAdminFee,
    propertyAdminFee = _props$propertyAdminF === void 0 ? undefined : _props$propertyAdminF,
    _props$propertyLateFe = props.propertyLateFee,
    propertyLateFee = _props$propertyLateFe === void 0 ? undefined : _props$propertyLateFe,
    residencyId = props.residencyId,
    setIsLoading = props.setIsLoading;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const propertyFee = lateFee ? propertyLateFee : propertyAdminFee;
  const _useState = useState(feeDescription || ''),
    _useState2 = _slicedToArray(_useState, 2),
    description = _useState2[0],
    setDescription = _useState2[1];
  const _useState3 = useState(customFee),
    _useState4 = _slicedToArray(_useState3, 2),
    feeValue = _useState4[0],
    setFeeValue = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isOpened = _useState6[0],
    setIsOpened = _useState6[1];
  useEffect(() => {
    setFeeValue(customFee);
  }, [customFee]);
  const getSign = v => lateFee && customLateFeeSign === FEE_UNIT_TYPES.percentage ? v + '%' : '$' + v;
  const feeText = () => {
    if (feeValue === null) {
      if (propertyFee === null) return 'Not set';else if (propertyFee >= 0) return getSign(propertyFee);
    } else if (feeValue >= 0) {
      return getSign(feeValue.toFixed(2));
    }
    return 'Not set';
  };
  const handleDiscardClick = () => {
    setFeeValue(customFee);
    setIsOpened(false);
  };
  const handleEditClick = () => setIsOpened(!isOpened);
  const handleRelink = async () => {
    setIsLoading(true);
    const data = {
      residencyId
    };
    if (lateFee) {
      data.lateFee = null;
      if (customAdminFee === null) data.adminFee = null;else data.adminFee = {
        feeUnitType: FEE_UNIT_TYPES.fixedAmount,
        value: customAdminFee
      };
    } else {
      data.adminFee = null;
      if (customLateFee === null) data.lateFee = null;else data.lateFee = {
        feeUnitType: customLateFeeSign,
        value: customLateFee
      };
    }
    const updateResidencyFeeResp = await store.payment.updateResidencyFeeAsync.run(data);
    if (updateResidencyFeeResp.isSuccessful) {
      handleChange(null);
      if (lateFee) handleCustomLateFeeSignChange(FEE_UNIT_TYPES.fixedAmount);
      setIsOpened(false);
      setDescription(feeDescription);
      setFetchFee(true);
      toast('success', {
        body: [t('unit_modal.successfull_relink')]
      });
    } else if (setIsLoading) setIsLoading(false);
  };
  const handleSaveClick = () => {
    handleSave(lateFee, feeValue);
    setDescription(t('unit_modal.custom_fee'));
    setIsOpened(false);
  };
  const handleSignChange = (e, value) => handleCustomLateFeeSignChange(value);
  return /*#__PURE__*/React.createElement(CustomFee, {
    customFee: customFee,
    description: description,
    feeText: feeText(),
    feeValue: feeValue,
    handleDiscardClick: handleDiscardClick,
    handleEditClick: handleEditClick,
    handleRelink: handleRelink,
    handleSaveClick: handleSaveClick,
    handleSignChange: handleSignChange,
    lateFee: lateFee,
    isOpened: isOpened,
    padding: padding,
    handleInputChange: v => setFeeValue(v),
    sign: customLateFeeSign
  });
});
export default BillingSettingsCustomFee;